export const RESET_PASSWORD_EVENTS = {
  VIEW_RESET_PASSWORD_SCREEN: 'view_reset_password_screen',
  SELECT_RESET_CHANGE_PASSWORD: 'select_reset_change_password',
  VIEW_RESET_PASSWORD_SUCCESS_TOAST: 'view_reset_password_success_toast',
  VIEW_RESET_PASSWORD_CHANGED_SUCCESS: 'view_reset_password_changed_success',
  DEEP_LINK_CHECK_MOBILE: 'deep_link_check_mobile',
  VIEW_CHANGED_PASSWORD_SCREEN: 'view_changed_password_screen',
  SELECT_CHANGED_PASSWORD_LOGIN: 'select_changed_password_login',
  VIEW_LINK_EXPIRED_SCREEN: 'view_link_expired_screen',
} as const;
